import { useServices } from "./useServices.js";
const usePdfWorkerSrc = ()=>useServices().pdfWorkerSrc;
export { usePdfWorkerSrc };
